import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Components/Navbar";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 text-gray-800">
      
      {/* 🔝 GLOBAL NAVBAR (fixed) */}
      <Navbar />

      {/* 🔳 MAIN CONTENT */}
      <main className="flex-1 pt-20 md:pt-28">
        <Outlet />
      </main>

      {/* 🔻 FOOTER */}
      <footer className="bg-black text-gray-300 mt-16">
        <div className="max-w-6xl mx-auto px-4 py-10 grid gap-10 md:grid-cols-3">

          {/* Column 1 */}
          <div>
            <h3 className="text-white text-lg font-semibold mb-3 tracking-wide">
              RelaxB
            </h3>
            <p className="text-sm leading-relaxed text-gray-400">
              Premium massage chairs, shampoo beds, and pedicure chairs for 
              salons, spas, and home wellness.
            </p>
          </div>

          {/* Column 2 */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-3 tracking-wide">
              Contact
            </h4>
            <ul className="space-y-1 text-sm text-gray-400">
              <li>Email: info@relaxb.com</li>
              <li>Phone: +1 (555) 123-4567</li>
              <li>Location: Canada</li>
            </ul>
          </div>

          {/* Column 3 */}
          <div>
            <h4 className="text-white text-sm font-semibold mb-3 tracking-wide">
              Follow Us
            </h4>
            <p className="text-sm text-gray-400">
              Instagram · Facebook · TikTok
            </p>
          </div>

        </div>

        <div className="border-t border-gray-800 text-xs text-gray-500 text-center py-4">
          © {new Date().getFullYear()} RelaxB. All rights reserved.
        </div>
      </footer>
    </div>
  );
}
